import React from "react";
import { Link } from "react-router-dom";

/**
 * ChunkyCuffsBanner — Homepage banner
 * -----------------------------------
 * Full-bleed square "Buy 1 Get 1 Free · Statement Cuffs" campaign artwork.
 * Displayed without any crop; entire artwork is clickable and routes to
 * the Chunky Cuffs collection page.
 */

const SQUARE_ART =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/9hwgv1r6_WhatsApp%20Image%202026-06-15%20at%2022.33.52.jpeg";

const ChunkyCuffsBanner = () => (
  <section
    data-testid="chunky-cuffs-banner"
    className="relative w-full bg-[#FDF6F0] py-14 sm:py-20 overflow-hidden reveal"
  >
    {/* soft top/bottom hairlines */}
    <div className="absolute top-0 left-1/2 -translate-x-1/2 h-px w-40 bg-[#C5985A]/40" />
    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 h-px w-40 bg-[#C5985A]/40" />

    <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
      {/* Editorial kicker */}
      <div className="flex items-center justify-center gap-4 mb-8 sm:mb-10">
        <span className="h-px w-10 bg-[#C5985A]/70" />
        <span className="text-[10px] sm:text-[11px] tracking-[0.55em] uppercase text-[#C5985A] font-medium">
          The Cuff Edit
        </span>
        <span className="h-px w-10 bg-[#C5985A]/70" />
      </div>

      <Link
        to="/shop?category=cuffs"
        data-testid="chunky-cuffs-cta"
        className="group relative block mx-auto"
        style={{ maxWidth: "620px" }}
        aria-label="Shop Chunky Cuffs — Buy 1 Get 1 Free"
      >
        {/* Cinematic frame — square, uncropped */}
        <div
          className="relative overflow-hidden"
          style={{
            aspectRatio: "1 / 1",
            boxShadow:
              "0 40px 80px -30px rgba(74,44,53,0.35), 0 12px 30px -12px rgba(197,152,90,0.28)",
          }}
        >
          <img
            src={SQUARE_ART}
            alt="Buy 1 Get 1 Free — Statement Cuffs"
            loading="lazy"
            className="w-full h-full object-contain bg-[#E9D9B9] transition-transform duration-[1600ms] ease-out group-hover:scale-[1.035]"
          />
          {/* subtle gold sweep on hover */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700"
            style={{
              background:
                "linear-gradient(115deg, transparent 40%, rgba(255,241,199,0.35) 50%, transparent 60%)",
            }}
          />
        </div>

        {/* CTA row below */}
        <div className="mt-6 flex flex-col items-center gap-3">
          <span
            data-testid="chunky-cuffs-shop-btn"
            className="inline-flex items-center gap-3 px-8 py-3 text-[11px] tracking-[0.4em] uppercase text-[#FDF6F0] bg-[#4A2C35] group-hover:bg-[#C5985A] transition-colors duration-500"
            style={{ boxShadow: "0 10px 24px -10px rgba(74,44,53,0.55)" }}
          >
            Shop the Cuffs
            <span
              aria-hidden
              className="inline-block transition-transform duration-500 group-hover:translate-x-1"
            >
              →
            </span>
          </span>
          <p className="text-center text-[10px] tracking-[0.4em] uppercase text-[#C5985A]/85">
            Buy 1 · Get 1 Free · Auto-applied at checkout
          </p>
        </div>
      </Link>
    </div>
  </section>
);

export default ChunkyCuffsBanner;
